<template>
    <div class="row">
        <div class="col-12">
            <label class="from-label">Ödeme Tarihi</label>
            <v-validator :errors="errors" parameter="PaidDate" :watch="value.PaidDate"> 
                <v-date-picker v-model="value.PaidDate" placeholder="Ödeme Tarihi"></v-date-picker>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>